export const GUIDED_EXPIRIENCE_QUERY_PARAM = 'guidedExpirience';
export const GUIDED_EXPERIENCE_QUERY_PARAM = 'guidedExperience';

type ShouldShowTaxDeliveryTooltipTourParams = {
  isTaxDeliveryDispatch: boolean;
  search: string;
  isDismissed: boolean;
};

export const shouldShowTaxDeliveryTooltipTour = ({
  isTaxDeliveryDispatch,
  search,
}: ShouldShowTaxDeliveryTooltipTourParams) => {
  if (!isTaxDeliveryDispatch) {
    return false;
  }

  const searchParams = new URLSearchParams(search);

  return (
    searchParams.get(GUIDED_EXPERIENCE_QUERY_PARAM) === 'true' ||
    searchParams.get(GUIDED_EXPIRIENCE_QUERY_PARAM) === 'true'
  );
};
